<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Productos</h1>
    <div class="results" v-if="products">
      <div class="results__element" v-for="(product, index) in products" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="product.title_es"></h2>
          <p v-if="product.designer" class="results__text">Marca: {{product.designer}}</p>
          <p v-if="product.price" class="results__text">Precio: {{product.price|price}}</p>
        </div>
        <div class="results__actions">
          <router-link :to="{name: 'inventoryView', params: {id: product.id}}" class="btn btn__icon btn__icon--regular results__btn results__btn--list">Inventario</router-link>
          <button @click.prevent="$parent.$emit('view', product.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Producto</button>
          <button @click.prevent="$parent.$emit('edit', product.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Producto</button>
          <button @click.prevent="deleteProduct(product.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Producto</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      productId: null,
      products: null,
      confirm: false
    }
  },
  created: function () {
    this.getProducts()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getProducts()
    },
    '$store.state.elementChanged': function () {
      this.getProducts()
    }
  },
  methods: {
    getProducts: function () {
      let httpRequest = {
        params: '?' + this.filters + '&sort=-id',
        module: 'products'
      }
      this.get(httpRequest)
        .then(
          products => {
            this.products = products.data
          }
        ).catch(
          () => {
            this.products = null
          }
        )
    },
    deleteProduct: function (id) {
      this.confirm = true
      this.productId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'products'
      }
      this.delete(this.productId, httpRequest)
        .then(
          response => {
            this.getProducts()
            this.$store.commit('notificate', {
              title: 'PRODUCTO BORRADO',
              text: 'El producto ha sido borrado correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'PRODUCTO NO BORRADO',
              text: 'No se pudo borrar el producto seleccionado, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/products/list.vue